export const dela = [
    {
        "file_name": "1",
        "avtor_name": "Elizabeta V.",
        "starost": "13",
        "drustvo": "PGD Nadgorica",
        "kategorija": "mladinci"
    },
    {
        "file_name": "2",
        "avtor_name": "Blaž P.",
        "starost": "12",
        "drustvo": "PGD Vižmarje-Brod",
        "kategorija": "mladinci"
    },
    {
        "file_name": "3",
        "avtor_name": "Domen Aleš V.",
        "starost": "14",
        "drustvo": "PGD Vižmarje-Brod",
        "kategorija": "mladinci"
    },
    {
        "file_name": "4",
        "avtor_name": "Eva K.",
        "starost": "12",
        "drustvo": "PGD Vižmarje-Brod",
        "kategorija": "mladinci"
    },
    {
        "file_name": "5",
        "avtor_name": "Lukas Č.",
        "starost": "13",
        "drustvo": "PGD Vižmarje-Brod",
        "kategorija": "mladinci"
    },
    {
        "file_name": "6",
        "avtor_name": "Neža M.",
        "starost": "13",
        "drustvo": "PGD Vižmarje-Brod",
        "kategorija": "mladinci"
    },
    {
        "file_name": "7",
        "avtor_name": "Peter P. T.",
        "starost": "15",
        "drustvo": "PGD Vižmarje-Brod",
        "kategorija": "mladinci"
    },
    {
        "file_name": "8",
        "avtor_name": "Filip D.",
        "starost": "11",
        "drustvo": "PGD Gameljne",
        "kategorija": "pionirji"
    },
    {
        "file_name": "9",
        "avtor_name": "Lenart F.",
        "starost": "12",
        "drustvo": "PGD Gameljne",
        "kategorija": "mladinci"
    },
    {
        "file_name": "10",
        "avtor_name": "Manca E.",
        "starost": "9",
        "drustvo": "PGD Ježica",
        "kategorija": "pionirji"
    },
    {
        "file_name": "11",
        "avtor_name": "Miha Š.",
        "starost": "11",
        "drustvo": "PGD Ježica",
        "kategorija": "pionirji"
    },
    {
        "file_name": "12",
        "avtor_name": "Žiga N.",
        "starost": "10",
        "drustvo": "PGD Ježica",
        "kategorija": "pionirji"
    },
    {
        "file_name": "13",
        "avtor_name": "Jan P.",
        "starost": "15",
        "drustvo": "PGD Ljubljana-Barje",
        "kategorija": "mladinci"
    },
    {
        "file_name": "14",
        "avtor_name": "Miha N.",
        "starost": "13",
        "drustvo": "PGD Ljubljana-Barje",
        "kategorija": "mladinci"
    },
    {
        "file_name": "15",
        "avtor_name": "Nick G.",
        "starost": "15",
        "drustvo": "PGD Ljubljana-Barje",
        "kategorija": "mladinci"
    },
    {
        "file_name": "16",
        "avtor_name": "Bor T.",
        "starost": "11",
        "drustvo": "PGD Ljubljana-Brdo",
        "kategorija": "pionirji"
    },
    {
        "file_name": "17",
        "avtor_name": "David H.",
        "starost": "12",
        "drustvo": "PGD Ljubljana-Brdo",
        "kategorija": "mladinci"
    },
    {
        "file_name": "18",
        "avtor_name": "Maruša K.",
        "starost": "10",
        "drustvo": "PGD Ljubljana-Brdo",
        "kategorija": "pionirji"
    },
    {
        "file_name": "19",
        "avtor_name": "Žana B.",
        "starost": "11",
        "drustvo": "PGD Ljubljana-Brdo",
        "kategorija": "pionirji"
    },
    {
        "file_name": "20",
        "avtor_name": "Antonija O.",
        "starost": "14",
        "drustvo": "PGD Nadgorica",
        "kategorija": "mladinci"
    },
    {
        "file_name": "21",
        "avtor_name": "Jerneja V.",
        "starost": "13",
        "drustvo": "PGD Nadgorica",
        "kategorija": "mladinci"
    },
    {
        "file_name": "22",
        "avtor_name": "Jonatan B.",
        "starost": "13",
        "drustvo": "PGD Nadgorica",
        "kategorija": "mladinci"
    },
    {
        "file_name": "23",
        "avtor_name": "Marko B.",
        "starost": "13",
        "drustvo": "PGD Nadgorica",
        "kategorija": "mladinci"
    },
    {
        "file_name": "24",
        "avtor_name": "Ožbolt O.",
        "starost": "12",
        "drustvo": "PGD Nadgorica",
        "kategorija": "mladinci"
    },
    {
        "file_name": "25",
        "avtor_name": "Sofia K. P.",
        "starost": "13",
        "drustvo": "PGD Nadgorica",
        "kategorija": "mladinci"
    },
    {
        "file_name": "26",
        "avtor_name": "Vid V.",
        "starost": "11",
        "drustvo": "PGD Nadgorica",
        "kategorija": "pionirji"
    },
    {
        "file_name": "27",
        "avtor_name": "Ana B.",
        "starost": "15",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "28",
        "avtor_name": "Avguština S.",
        "starost": "11",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "pionirji"
    },
    {
        "file_name": "29",
        "avtor_name": "Evgen S.",
        "starost": "12",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "30",
        "avtor_name": "Filip Z.",
        "starost": "15",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "31",
        "avtor_name": "Jakov Z.",
        "starost": "15",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "32",
        "avtor_name": "Jernej K.",
        "starost": "12",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "33",
        "avtor_name": "Katja P.",
        "starost": "13",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "34",
        "avtor_name": "Lili Z.",
        "starost": "14",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "35",
        "avtor_name": "Marko Erik V.",
        "starost": "15",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "36",
        "avtor_name": "Oskar R.",
        "starost": "11",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "pionirji"
    },
    {
        "file_name": "37",
        "avtor_name": "Patricija S.",
        "starost": "14",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "38",
        "avtor_name": "Tiara P.",
        "starost": "14",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "39",
        "avtor_name": "Timotej K.",
        "starost": "14",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "40",
        "avtor_name": "Vitja J. Š.",
        "starost": "12",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "41",
        "avtor_name": "Zarja G.",
        "starost": "16",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "pripravniki"
    },
    {
        "file_name": "42",
        "avtor_name": "Klara K.",
        "starost": "16",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "pripravniki"
    },
    {
        "file_name": "43",
        "avtor_name": "Matheo J. Š",
        "starost": "12",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "44",
        "avtor_name": "Matic S.",
        "starost": "14",
        "drustvo": "PGD Podgorica-Šentjakob",
        "kategorija": "mladinci"
    },
    {
        "file_name": "45",
        "avtor_name": "Jakob Filip B. V.",
        "starost": "13",
        "drustvo": "PGD Podutik-Glince",
        "kategorija": "mladinci"
    },
    {
        "file_name": "46",
        "avtor_name": "Mojca D.",
        "starost": "9",
        "drustvo": "PGD Podutik-Glince",
        "kategorija": "pionirji"
    },
    {
        "file_name": "47",
        "avtor_name": "David S.",
        "starost": "16",
        "drustvo": "PGD Prežganje",
        "kategorija": "pripravniki"
    },
    {
        "file_name": "48",
        "avtor_name": "Brina J.",
        "starost": "13",
        "drustvo": "PGD Sostro",
        "kategorija": "mladinci"
    },
    {
        "file_name": "49",
        "avtor_name": "Eva G. R.",
        "starost": "15",
        "drustvo": "PGD Sostro",
        "kategorija": "mladinci"
    },
    {
        "file_name": "50",
        "avtor_name": "Gaj H. P.",
        "starost": "14",
        "drustvo": "PGD Sostro",
        "kategorija": "mladinci"
    },
    {
        "file_name": "51",
        "avtor_name": "Jan G. R.",
        "starost": "14",
        "drustvo": "PGD Sostro",
        "kategorija": "mladinci"
    },
    {
        "file_name": "52",
        "avtor_name": "Juš P.",
        "starost": "14",
        "drustvo": "PGD Sostro",
        "kategorija": "mladinci"
    },
    {
        "file_name": "53",
        "avtor_name": "Mark G.",
        "starost": "13",
        "drustvo": "PGD Sostro",
        "kategorija": "mladinci"
    },
    {
        "file_name": "54",
        "avtor_name": "Matic J.",
        "starost": "15",
        "drustvo": "PGD Sostro",
        "kategorija": "mladinci"
    },
    {
        "file_name": "55",
        "avtor_name": "Ajda B.",
        "starost": "14",
        "drustvo": "PGD Stožice",
        "kategorija": "mladinci"
    },
    {
        "file_name": "56",
        "avtor_name": "Blaž H.",
        "starost": "16",
        "drustvo": "PGD Stožice",
        "kategorija": "pripravniki"
    },
    {
        "file_name": "57",
        "avtor_name": "Kara K.",
        "starost": "14",
        "drustvo": "PGD Stožice",
        "kategorija": "mladinci"
    },
    {
        "file_name": "58",
        "avtor_name": "Tilen M.",
        "starost": "16",
        "drustvo": "PGD Stožice",
        "kategorija": "pripravniki"
    },
    {
        "file_name": "59",
        "avtor_name": "Vesna H.",
        "starost": "13",
        "drustvo": "PGD Stožice",
        "kategorija": "mladinci"
    },
    {
        "file_name": "60",
        "avtor_name": "Adnan K.",
        "starost": "14",
        "drustvo": "PGD Tomačevo-Jarše",
        "kategorija": "mladinci"
    },
    {
        "file_name": "61",
        "avtor_name": "Gašper B.",
        "starost": "14",
        "drustvo": "PGD Tomačevo-Jarše",
        "kategorija": "mladinci"
    },
    {
        "file_name": "62",
        "avtor_name": "Mark S.",
        "starost": "12",
        "drustvo": "PGD Tomačevo-Jarše",
        "kategorija": "mladinci"
    },
    {
        "file_name": "63",
        "avtor_name": "Žan K. H.",
        "starost": "13",
        "drustvo": "PGD Tomačevo-Jarše",
        "kategorija": "mladinci"
    },
    {
        "file_name": "64",
        "avtor_name": "Jurij B.",
        "starost": "16",
        "drustvo": "PGD Ljubljana Trnovo",
        "kategorija": "pripravniki"
    },
    {
        "file_name": "65",
        "avtor_name": "Tara V.",
        "starost": "14",
        "drustvo": "PGD Ljubljana Trnovo",
        "kategorija": "mladinci"
    },
    {
        "file_name": "66",
        "avtor_name": "Ula V.",
        "starost": "12",
        "drustvo": "PGD Ljubljana Trnovo",
        "kategorija": "mladinci"
    },
    {
        "file_name": "67",
        "avtor_name": "Filip Č.",
        "starost": "15",
        "drustvo": "PGD Zalog-Sp. Kašelj",
        "kategorija": "mladinci"
    },
    {
        "file_name": "68",
        "avtor_name": "Luka M.",
        "starost": "14",
        "drustvo": "PGD Zalog-Sp. Kašelj",
        "kategorija": "mladinci"
    },
    {
        "file_name": "69",
        "avtor_name": "Tara O.",
        "starost": "14",
        "drustvo": "PGD Zalog-Sp. Kašelj",
        "kategorija": "mladinci"
    }
]